import {useEffect, useState} from "react";

const PAGE_SIZE = 10;

export default (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [activities, setActivities] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);

    const fetchActivities = async (page) => {
        setLoading(true);
        try {

            const res = props.ctx.ajax(window.config.api + "/profile/all_trade/" + page, {
                authToken: props.ctx.auth
            }).then(function (data) {
                setActivities(data || []);
                setTotalPages(5);
            })

        } catch (e) {
            console.error("خطا در دریافت اطلاعات:", e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchActivities(currentPage);
    }, [currentPage]);

    const renderStatus = (status) => {
        switch (status) {
            case 0:
                return "در انتظار بررسی";
            case 1:
                return "تایید شده";
            case 2:
                return "رد شده";
            default:
                return "نامشخص";
        }
    };

    return (
        <div className="container mt-4 mb-4">
            <h5 className="mb-4">ترید های من</h5>

            {activities.length === 0 ? (
                <p className="text-muted">هیچ تریدی ثبت نشده است.</p>
            ) : (
                <>
                    <div className="table-responsive">
                        <table className="table table-bordered text-center align-middle">
                            <thead className="table-light">
                            <tr>
                                <th>#</th>
                                <th>نوع</th>
                                <th>مبلغ</th>
                                <th>ضریب</th>
                                <th>مبلغ نهایی</th>
                                <th>تاریخ</th>
                                <th>وضعیت</th>
                            </tr>
                            </thead>
                            <tbody>
                            {activities.map((item, idx) => (
                                <tr key={item.id}>
                                    <td>{(currentPage - 1) * PAGE_SIZE + idx + 1}</td>
                                    <td>{item.mode === 'buy'?"خرید":"فروش"}</td>
                                    <td>{props.ctx.addCommos(item.amount , 2)} {item.trade === "TOM" ? "تومان" : "تتر"}</td>
                                    <td>{props.ctx.addCommos(item.changer , 2)}  </td>
                                    <td>{props.ctx.addCommos(item.after , 2)} {item.trade === "TOM" ? "تتر" : "تومان"}</td>
                                    <td>{new Date(item.timestamp * 1000).toLocaleString("fa-IR")}</td>
                                    <td>{renderStatus(item.status)}</td>

                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}

                </>
            )}
            <nav>
                <ul className="pagination justify-content-center mt-3">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button
                            className="page-link"
                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                        >
                            قبلی
                        </button>
                    </li>

                    <li className="page-item   active">
                                <span className="page-link">
                                    صفحه {currentPage}
                                </span>
                    </li>

                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                        <button
                            className="page-link"
                            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                        >
                            بعدی
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    );
};
